import axios from 'axios';

import { handleRequestError } from 'helpers/network';

const apiClient = axios.create({
  baseURL: window.API_URL,
  withCredentials: true
});

apiClient.interceptors.response.use(undefined, (error) =>
  Promise.reject(handleRequestError(error))
);

export default apiClient;
